import React from "react";
import SchoolIcon from "@mui/icons-material/School";
import ClassIcon from "@mui/icons-material/Class";

function ClassesModal({ classes, onClose }) {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.75)",
        backdropFilter: "blur(10px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
        padding: 20,
      }}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: "100%",
          maxWidth: 580,
          maxHeight: "80vh",
          background: "linear-gradient(135deg, #223562 0%, #153e65 55%, #265e81 100%)",
          borderRadius: 20,
          boxShadow:
            "0 20px 60px rgba(0,0,0,0.5), inset 0 0 0 1px rgba(255,255,255,0.1)",
          overflow: "hidden",
          animation: "slideIn 0.3s ease-out",
          fontFamily: "Inter, sans-serif",
        }}
      >
        {/* HEADER */}
        <div
          style={{
            padding: "14px 18px",
            borderBottom: "1px solid rgba(255,255,255,0.15)",
            display: "flex",
            alignItems: "center",
            gap: 10,
          }}
        >
          <div
            style={{
              width: 36,
              height: 36,
              borderRadius: 10,
              background: "linear-gradient(135deg, #080F1F 0%, #102A43 55%, #1B4965 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <SchoolIcon sx={{ color: "#FFE8C2", fontSize: 18 }} />
          </div>

          <div>
            <h2 style={{ margin: 0, color: "#fff", fontSize: 18 }}>
              Classes & Sections
            </h2>
            <p style={{ margin: 0, fontSize: 11, color: "rgba(255,255,255,.7)" }}>
              Academic Structure Overview
            </p>
          </div>
        </div>

        {/* BODY */}
        <div
          style={{
            padding: "16px 18px",
            overflowY: "auto",
            maxHeight: "calc(80vh - 140px)",
          }}
        >
          {classes.length === 0 ? (
            <p style={{ color: "#FFE8C2", textAlign: "center" }}>
              No classes found
            </p>
          ) : (
            classes.map((cls, i) => (
              <div
                key={i}
                style={{
                  background: "linear-gradient(135deg, #080F1F 0%, #102A43 55%, #1B4965 100%)",
                  borderRadius: 14,
                  padding: 12,
                  marginBottom: 10,
                }}
              >
                <h4
                  style={{
                    margin: "0 0 6px",
                    color: "#FFF7ED",
                    fontSize: 14,
                    fontWeight: 700,
                  }}
                >
                  {cls.className}
                </h4>

                {cls.sections.map((sec, idx) => (
                  <div
                    key={idx}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: 12,
                      color: "#fff",
                      marginTop: 4,
                    }}
                  >
                    <span style={{ display: "flex", gap: 6 }}>
                      <ClassIcon sx={{ fontSize: 14, color: "#FDBA74" }} />
                      {sec.sectionName}
                    </span>

                    <span
                      style={{
                        background:
                          "linear-gradient(135deg, #080F1F 0%, #102A43 55%, #1B4965 100%)",
                        borderRadius: 999,
                        padding: "2px 10px",
                        fontSize: 11,
                        fontWeight: 700,
                      }}
                    >
                      {sec.studentCount}
                    </span>
                  </div>
                ))}
              </div>
            ))
          )}
        </div>

        {/* FOOTER */}
        <div
          style={{
            padding: "12px 18px",
            borderTop: "1px solid rgba(255,255,255,0.15)",
            display: "flex",
            justifyContent: "flex-end",
            background: "linear-gradient(135deg, #080F1F 0%, #102A43 55%, #1B4965 100%)",
          }}
        >
          <button
            onClick={onClose}
            style={{
              padding: "8px 22px",
              borderRadius: 10,
              background: "linear-gradient(135deg, #080F1F 0%, #102A43 55%, #1B4965 100%)",
              color: "#eff2f6",
              fontWeight: 700,
              border: "none",
              cursor: "pointer",
            }}
          >
            Close
          </button>
        </div>
      </div>

      <style>
        {`
        @keyframes slideIn {
          from { opacity:0; transform: translateY(-20px) scale(.95); }
          to { opacity:1; transform: translateY(0) scale(1); }
        }
        `}
      </style>
    </div>
  );
}

export default ClassesModal;
